import { parsePhoneNumberFromString } from 'libphonenumber-js'

// Pretty-print an E.164 number the way the design shows it: "+1 (617) 555-8198".
// Falls back to the raw string for anything libphonenumber can't parse.
export function formatPhone(e164: string | null | undefined): string {
  const raw = String(e164 || '').trim()
  if (!raw) return ''
  try {
    const pn = parsePhoneNumberFromString(raw)
    if (pn) return pn.countryCallingCode === '1' ? `+1 ${pn.formatNational()}` : pn.formatInternational()
  } catch {
    /* fall through to raw */
  }
  return raw
}

export function toE164(input: string): string | null {
  const pn = parsePhoneNumberFromString(input.trim(), 'US')
  return pn?.isValid() ? pn.number : null
}

// What a line is, as a rep would name it.
const PHONE_TYPE_LABELS: Record<string, string> = {
  mobile: 'Mobile',
  work: 'Work',
  work_hq: 'Main line',
  home: 'Home',
  fax: 'Fax',
}

export function phoneTypeLabel(phoneType: string | null | undefined): string {
  return PHONE_TYPE_LABELS[String(phoneType || '')] || 'Phone'
}

// ISO-3166 alpha-2 → display name ("GB" → "United Kingdom"), via the browser's
// Intl.DisplayNames. Falls back to the raw code if it can't be resolved.
// One instance — this runs inside the rail's render loop.
const _regionNames = (() => {
  try {
    return new Intl.DisplayNames(['en'], { type: 'region' })
  } catch {
    return null
  }
})()

export function countryName(code: string | null | undefined): string {
  const c = String(code || '').trim().toUpperCase()
  if (!c) return ''
  try {
    return _regionNames?.of(c) || c
  } catch {
    return c
  }
}
